import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    message: PropTypes.string,
};

const defaultProps = {
    message: '',
};

const MessagePreview = ({ message }) => {
    return (
        <div className="preview">
            <p>Preview:</p>
            <p>{message}</p>
        </div>
    );
};

MessagePreview.propTypes = propTypes;
MessagePreview.defaultProps = defaultProps;

export default MessagePreview;
